<template>
  <div class="split"></div>
</template>

<script type="text/ecmascript-6">
  export default {};
</script>

<style>
  @import "split.css";
</style>



// WEBPACK FOOTER //
// split.vue?64a25fa9